import React from 'react';

export type LimitVariant = 'yes' | 'soft' | 'hard' | 'curious';

export interface LimitTagProps {
  label: string;
  variant: LimitVariant;
  className?: string;
}


const VARIANT_CLASSES: Record<LimitVariant, string> = {
  yes: 'bg-[rgba(95,184,141,0.10)] text-[var(--theme-consent-yes)] border-[rgba(95,184,141,0.2)]',
  soft: 'bg-[rgba(224,173,69,0.10)] text-[var(--theme-consent-soft)] border-[rgba(224,173,69,0.2)]',
  hard: 'bg-[rgba(208,96,96,0.10)] text-[var(--theme-consent-hard)] border-[rgba(208,96,96,0.2)]',
  curious: 'bg-[rgba(110,164,196,0.10)] text-[var(--theme-consent-curious)] border-[rgba(110,164,196,0.2)]',
};

export function LimitTag({ label, variant, className }: LimitTagProps) {
  return (
    <span
      className={[
        'inline-flex items-center px-[14px] py-[6px] rounded-[6px] text-[13px] font-medium border',
        VARIANT_CLASSES[variant],
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {label}
    </span>
  );
}
